// src/pages/Mentors.js (ya .jsx)
import React from "react";
import { useNavigate } from "react-router-dom";
import "./../../assets/css/mentor/mentors.css";

// ✅ Real image imports
import tabindaImg from "./../../assets/images/mentor.jpg";
import anumImg from "./../../assets/images/anum.jpeg";
import maheenImg from "./../../assets/images/maheen.jpeg";
import javeriaImg from "./../../assets/images/javeria.jpeg";
import mahnoorImg from "./../../assets/images/mahnoor.jpeg";
import bilalImg from "./../../assets/images/bilal.jpeg";

const Mentors = () => {
  const navigate = useNavigate();

  const mentorsData = [
    {
      id: 1,
      name: "Mam Tabinda",
      role: "Senior Web Developer",
      expertise: "React & Node.js",
      students: 250,
      courses: 8,
      rating: 4.9,
      email: "tabinda@techmentor.com",
      image: tabindaImg,
    },
    {
      id: 2,
      name: "Mam Anum",
      role: "Full Stack Architect",
      expertise: "MERN Stack",
      students: 320,
      courses: 12,
      rating: 5.0,
      email: "anum@techmentor.com",
      image: anumImg,
    },
    {
      id: 3,
      name: "Mam Maheen",
      role: "Frontend Specialist",
      expertise: "HTML, CSS, JavaScript",
      students: 180,
      courses: 6,
      rating: 4.8,
      email: "maheen@techmentor.com",
      image: maheenImg,
    },
    {
      id: 4,
      name: "Mam Javeria",
      role: "Backend Expert",
      expertise: "Python & Django",
      students: 290,
      courses: 10,
      rating: 4.9,
      email: "javeria@techmentor.com",
      image: javeriaImg,
    },
    {
      id: 5,
      name: "Mam Mahnoor",
      role: "Mobile App Developer",
      expertise: "React Native",
      students: 200,
      courses: 7,
      rating: 4.7,
      email: "mahnoor@techmentor.com",
      image: mahnoorImg,
    },
    {
      id: 6,
      name: "Sir Bilal",
      role: "DevOps Engineer",
      expertise: "AWS & Docker",
      students: 150,
      courses: 5,
      rating: 4.8,
      email: "bilal@techmentor.com",
      image: bilalImg,
    },
  ];

  // ✅ Navigate with mentor data
  const handleCardClick = (mentor) => {
    navigate(`/mentor/${mentor.id}`, {
      state: { mentorData: mentor },
    });
  };

  return (
    <div className="mentors-container">
      {/* ========== NEW HERO SECTION ========== */}
      <section className="mentors-hero-section-new">
        {/* Left Content */}
        <div className="hero-left-content">
          <div className="hero-greeting">Hi, there!</div>
          <h1 className="hero-main-heading">
            <span className="hero-highlight">MENTORS</span> ARE HERE TO BE YOUR
            GUIDE
          </h1>
          <p className="hero-description">
            We are here ready to help you in making your tech journey successful
            with expert guidance and personalized mentorship.
          </p>
          <button className="hero-cta-button">Let's Discuss</button>

          {/* Service Tags */}
          <div className="hero-services">
            <h3 className="services-title">OUR SERVICE</h3>
            <div className="services-grid">
              <div className="service-item">
                <div className="service-icon">📚</div>
                <h4>Learning Path</h4>
                <p>Customized roadmap for your success journey</p>
              </div>
              <div className="service-item">
                <div className="service-icon">💻</div>
                <h4>Hands-on Projects</h4>
                <p>Real-world experience with live projects</p>
              </div>
              <div className="service-item">
                <div className="service-icon">🎯</div>
                <h4>Career Guidance</h4>
                <p>Expert advice for your professional growth</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content - Image & Floating Stats */}
        <div className="hero-right-content">
          <div className="hero-image-wrapper">
            {/* Decorative Blob Background */}
            <div className="hero-blob"></div>

            {/* Mentor Image */}
            <img
              src={anumImg}
              alt="Mam Anum - Mentor"
              className="hero-mentor-image"
            />

            {/* Floating Stats Cards */}
            <div className="floating-stat stat-1">
              <div className="stat-icon">👥</div>
              <div className="stat-content">
                <div className="stat-number">250+</div>
                <div className="stat-label">Students Mentored</div>
              </div>
            </div>

            <div className="floating-stat stat-2">
              <div className="stat-icon">⭐</div>
              <div className="stat-content">
                <div className="stat-number">4.9</div>
                <div className="stat-label">Rating</div>
              </div>
            </div>

            <div className="floating-stat stat-3">
              <div className="stat-icon">💼</div>
              <div className="stat-content">
                <div className="stat-number">8 Years</div>
                <div className="stat-label">Experience</div>
              </div>
            </div>

            {/* Decorative Dots */}
            <div className="hero-dots hero-dots-top"></div>
            <div className="hero-dots hero-dots-bottom"></div>
          </div>
        </div>
      </section>

      {/* ========== MENTORS CARDS SECTION ========== */}
      <section className="mentors-cards-section">
        <div className="mentors-cards-background" />
        <h2 className="mentors-section-title">Our Mentoring Team</h2>

        <div className="mentors-cards-grid">
          {mentorsData.map((mentor, index) => (
            <div
              key={mentor.id}
              className="mentors-mentor-card"
              style={{
                animationDelay: `${0.3 + index * 0.15}s`,
              }}
              onClick={() => handleCardClick(mentor)}
            >
              <div className="mentors-mentor-avatar">
                <img src={mentor.image} alt={mentor.name} />
              </div>

              <h3 className="mentors-mentor-name">{mentor.name}</h3>
              <p className="mentors-mentor-role">{mentor.role}</p>
              <p className="mentors-mentor-expertise">{mentor.expertise}</p>

              <div className="mentors-mentor-stats">
                <div className="mentors-stat-item">
                  <span>{mentor.students}+</span>
                  <span>Students</span>
                </div>
                <div className="mentors-stat-item">
                  <span>{mentor.courses}</span>
                  <span>Courses</span>
                </div>
              </div>

              <button className="mentors-contact-button">Contact Mentor</button>

              <div style={{ marginTop: "10px", fontSize: "0.9rem" }}>
                ⭐ {mentor.rating} rating
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Mentors;
